export enum ChatAgent {
	WEB_CHAT_ORCHESTRATOR = 'web-chat-orchestrator',
	WEB_CHAT_MELI = 'web-chat-meli',
	WEB_CHAT_GENERAL = 'web-chat-general',
	WEB_CHAT_SALES = 'web-chat-sales',
	WEB_CHAT_SUPPORT = 'web-chat-support',
}
